const BINARY_KB = 1024;
const BINARY_MB = BINARY_KB * 1024;

/** Byte size for limits and validation copy, e.g. `20 MB`. */
export const formatByteLimit = (bytes: number): string => {
	const mb = bytes / BINARY_MB;

	return Number.isInteger(mb) ? `${mb} MB` : `${parseFloat(mb.toFixed(1))} MB`;
};

type FormatBytesOptions = {
	decimals?: number;
};

/** Binary (1024) byte size with auto KB/MB unit. */
export const formatBytes = (bytes: number, { decimals = 2 }: FormatBytesOptions = {}): string => {
	const mb = bytes / BINARY_MB;

	if (mb >= 1) {
		return `${mb.toFixed(decimals)} MB`;
	}

	return `${(bytes / BINARY_KB).toFixed(decimals)} KB`;
};
